export default "__VITE_ASSET__C0OIznW9__"